module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Api_Widget', {
		configure: function() {
			this.registerOptions('', {
				manualRender: true,
				autoLoad: false,
				widgets: {
					api: {
						widget: 'Api'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		initWithChildren: function() {
			this.successTemplate = this.requireOption('template');
			this.failureTemplate = this.getOption('failureTemplate');

			if (this.getOption('apiWidget')) {
				this._api = this.rwom1(this.getOption('apiWidget'));
			} else {
				this._api = this.rwom1('#api');
				this._api.setOption('method', this.requireOption('method'));
			}

			if (this.getOption('autoLoad')) {
				this.load();
			}
			
			this.callParent('initWithChildren', arguments);
		},

		activating: function() {
			this.callParent('activating', arguments);

			if (this.getOption('autoLoad')) {
				this.load();
			}
		},

		load: function(apiParams) {
			var params = fox.merge(this.getOption('apiParams') || {}, apiParams || {});

			return this._api.psend(params).then(function (resp) {
				this.setOption('template', this.successTemplate).setTemplateOptions({data: resp.params.answer.response}).render();
			}.bind(this)).catch(function (resp) {
				if (this.failureTemplate) {
					this.setOption('template', this.failureTemplate).setTemplateOptions({data: resp.params.answer.response}).render();
				}
			}.bind(this));
		}

	}, 'Widget');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/data/widget.js
// module id = 184
// module chunks = 0